import { useQuery } from '@tanstack/react-query';
import { searchService } from './search.service';
import { storesApi } from '@/src/app/[locale]/stores/services/stores.service';

const useProducts = (keyword: string, isStorePage?: boolean) => {
  return useQuery({
    queryKey: ['products', keyword],
    queryFn: async () => await searchService.fetchProducts(keyword),
    enabled: !!keyword, // Only run the query if keyword is provided,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
  });
};

const useSuggestedIndustries = () => {
  return useQuery({
    queryKey: ['suggestedProducts'],
    queryFn: async () => await storesApi.getStoresIndustries(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};

export { useSuggestedIndustries, useProducts };
